import {
  ParkingPlaceSource,
  ParkingPlaceSourceDescriptions,
  ParkingPlaceSourceLabels,
  ParkingPlaceStructure,
  ParkingPlaceStructureDescriptions,
  ParkingPlaceStructureLabels,
  ParkingPlaceType,
  ParkingPlaceTypeDescriptions,
  ParkingPlaceTypeLabels,
  ResourceStatus,
  ResourceStatusDescriptions,
  ResourceStatusLabels
} from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';

/** Unique icon per parking-place choice. One icon is never reused across these filters. */
export const PARKING_PLACE_TYPE_ICON: Record<ParkingPlaceType, NoddiIconName> = {
  BOUNDED_AREA: 'Square',
  PARKING_HOUSE: 'Warehouse',
  PRIVATE_GARAGE: 'Home',
  STREET: 'Route'
};

const PARKING_PLACE_STATUS_ICON: Record<ResourceStatus, NoddiIconName> = {
  ACTIVE: 'CircleCheck',
  DISABLED_HIDE: 'EyeOff',
  DISABLED_SHOW: 'Eye',
  OUT_OF_ORDER: 'TriangleAlert'
};

export const PARKING_PLACE_SOURCE_ICON: Record<ParkingPlaceSource, NoddiIconName> = {
  CUSTOMER_REPORTED: 'MessageSquare',
  MANUAL: 'Edit',
  STATENS_VEGVESEN: 'Database'
};

export const PARKING_PLACE_STRUCTURE_ICON: Record<ParkingPlaceStructure, NoddiIconName> = {
  ABOVE_GROUND: 'Sun',
  MIXED: 'Layers',
  UNDERGROUND: 'ArrowDown',
  UNKNOWN: 'CircleHelp'
};

const choiceOptions = <T extends string>(
  values: Record<string, T>,
  labels: Record<T, string>,
  descriptions: Record<T, string>,
  icons: Record<T, NoddiIconName>
) =>
  Object.values(values).map((value) => ({
    value,
    label: labels[value],
    description: descriptions[value],
    icon: icons[value]
  }));

export const parkingPlaceTypeFilterOptions = choiceOptions(
  ParkingPlaceType,
  ParkingPlaceTypeLabels,
  ParkingPlaceTypeDescriptions,
  PARKING_PLACE_TYPE_ICON
);

export const parkingPlaceStatusFilterOptions = choiceOptions(
  ResourceStatus,
  ResourceStatusLabels,
  ResourceStatusDescriptions,
  PARKING_PLACE_STATUS_ICON
);

export const parkingPlaceSourceFilterOptions = choiceOptions(
  ParkingPlaceSource,
  ParkingPlaceSourceLabels,
  ParkingPlaceSourceDescriptions,
  PARKING_PLACE_SOURCE_ICON
);

export const parkingPlaceStructureFilterOptions = choiceOptions(
  ParkingPlaceStructure,
  ParkingPlaceStructureLabels,
  ParkingPlaceStructureDescriptions,
  PARKING_PLACE_STRUCTURE_ICON
);
